module.exports = __webpack_public_path__ + "static/media/vps-open-claw.b6b3252b.png";